import React, {Fragment, useRef} from 'react';
import PropTypes from 'prop-types';
import Dialog from 'react-bootstrap-dialog';
import {Button, Form} from 'react-bootstrap';
import {Formik} from 'formik';
import {useTranslation} from 'react-i18next';
import {deleteUserBooking, saveUserBooking, deleteServiceUserBooking, saveServiceUserBooking, deleteBookingSeries, searchPlayers as searchPartnerPlayers} from '../actions/partner';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {AiOutlineUser} from 'react-icons/ai';
import {FaDivide, FaSave, FaShieldAlt, FaSyncAlt, FaTrash, FaUsers} from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import PartnerBookingSubscriptionParticipant, {participantFullName} from './partner-booking-subscription-participant';
import 'react-datepicker/dist/react-datepicker.css';
import '../css/partner-booking.css';

export const applyMemberDiscount = (price, discount) => {
  const normalizedPrice = Math.max(Number(price) || 0, 0);
  const normalizedDiscount = Math.min(Math.max(Number(discount) || 0, 0), 100);
  return Math.round(normalizedPrice * (100 - normalizedDiscount)) / 100;
};

export const PartnerBooking = ({booking, slot, slots, field, partner, save, resourceType = 'field', deleteUserBooking, saveUserBooking, deleteServiceUserBooking, saveServiceUserBooking, deleteBookingSeries, searchPlayers, ownedFieldSlots, discount = 0}) => {
  const {t, i18n} = useTranslation();
  const memberFullPrices = useRef({});
  const resizeArray = (arr, newSize, defaultValue) => {
    const current = Array.isArray(arr) ? arr : [];
    if (newSize > current.length) {
      return [...current, ...new Array(newSize - current.length).fill(defaultValue)];
    }

    return current.slice(0, newSize);
  };

  const startSlot = () => {
    if ((slot && slot.bookingId) || (slots && slots[0] && slots[0].bookingId)) {
      let s = ownedFieldSlots.filter(s => s.bookingId === slot.bookingId).reverse();
      if (s.length > 0) {
        return s[0];
      }
    }
    if (slots) {
      return slots[0];
    }
    return slot;
  };

  const endSlot = () => {
    if ((slot && slot.bookingId) || (slots && slots[0] && slots[0].bookingId)) {
      let s = ownedFieldSlots.filter(s => s.bookingId === slot.bookingId).reverse();
      if (s.length > 0) {
        return s[s.length - 1];
      }
    }
    if (slots) {
      return slots[slots.length - 1];
    }

    return slot;
  };

  let dialog = null;
  const onRemoveUserBooking = (fieldId, userBookingId) => {
    dialog.show({
      title: t('CONFIRM'),
      body: t('CONFIRM_DELETE_USER_FROM_BOOKING'),
      actions: [
        Dialog.Action(
          t('DELETE'),
          () => resourceType === 'field' ? deleteUserBooking(fieldId, userBookingId) : deleteServiceUserBooking(fieldId, userBookingId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('NO'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const onRemoveSeries = (seriesId, type, resourceId) => {
    dialog.show({
      title: t('CONFIRM'),
      body: t('BOOKING_SERIES_DELETE_CONFIRM'),
      actions: [
        Dialog.Action(
          t('DELETE'),
          () => deleteBookingSeries(seriesId, type, resourceId),
          'btn btn-secondary'
        ),
        Dialog.Action(t('NO'), null, 'btn btn_red_outline_rp')
      ],
      bsSize: 'small',
      onHide: currentDialog => currentDialog.hide()
    });
  };

  const changeUserBooking = (fieldId, user) => () => {
    dialog.show({
      title: t('USERS_BOOKING_LIST'),
      body: <Formik
              initialValues={user}
              onSubmit={resourceType === 'field' ? saveUserBooking : saveServiceUserBooking}
            >
              {({
                handleSubmit,
                handleChange,
                values
              }) => {    
                return (
                  <Form key={values.id} onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Label>{t('NAME')}</Form.Label>
                      <Form.Control name="partnerBookingName" placeholder={t('NAME')} type="text" maxLength="50" value={values.partnerBookingName || ''} onChange={handleChange}/>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{t('SURNAME')}</Form.Label>
                      <Form.Control name="partnerBookingSurname" placeholder={t('SURNAME')} type="text" maxLength="50" value={values.partnerBookingSurname || ''} onChange={handleChange}/>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{t('EMAIL')}</Form.Label>
                      <Form.Control name="partnerBookingEmail" placeholder={t('EMAIL')} type="text" maxLength="255" value={values.partnerBookingEmail || ''} onChange={handleChange}/>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{t('TELEPHONE')}</Form.Label>
                      <Form.Control name="partnerBookingPhoneNumber" type="tel" placeholder={t('TELEPHONE')} value={values.partnerBookingPhoneNumber || ''} onChange={handleChange}/>
                    </Form.Group>
                    <Form.Group>
                      <Form.Check name="payment" type="checkbox" label={t('PAID')} checked={values.payment} onChange={handleChange}/>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{t('BOOKING_NOTES')}</Form.Label>
                      <Form.Control name="bookingNotes" as="textarea" rows={4} maxLength={255} placeholder={t('BOOKING_NOTES')} value={values.bookingNotes || ''} onChange={handleChange}/>
                    </Form.Group>
                    <Button type="submit" variant="secondary" style={{marginBottom: 50}}>{t('SAVE')}</Button>
                  </Form>
                );
              }}
            </Formik>,
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        ),
        Dialog.Action(
          t('DELETE'),
          () => startSlot().minimumPlayers == null ? onRemoveUserBooking(fieldId, user.id) :  deleteUserBooking(fieldId, user.id),
          'btn btn-secondary'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const slotPrice = () => {
    if (slots) {
      return slots.reduce((price, currentSlot) => price + currentSlot.price, 0);
    }
    return slot.price;
  };

  const description = slot ? slot.description ? slot.description : "" : slots[0].description ? slots[0].description : "";
  const bookingOwner = booking.users && booking.users.length > 0 ? booking.users[0] : null;
  const bookingNotes = bookingOwner ? bookingOwner.bookingNotes : "";
  const payment = bookingOwner ? bookingOwner.payment : false;
  const bookingSlot = slot || slots[0];
  const bookingStart = new Date(bookingSlot.startDatetime);
  const defaultUntilDate = new Date(bookingStart);
  defaultUntilDate.setDate(defaultUntilDate.getDate() + 28);
  const defaultWeekDay = bookingStart.getDay() === 0 ? 6 : bookingStart.getDay() - 1;
  const isNewPartnerBooking = !booking.bookingId;
  const isInvitationSlot = Number(bookingSlot.presetPlaces) > 1
    && bookingSlot.minimumPlayers !== null
    && bookingSlot.minimumPlayers !== undefined;
  const isPartnerOwnedBooking = Boolean(
    booking.bookingId
    && partner.uid !== null
    && partner.uid !== undefined
    && Array.isArray(booking.users)
    && booking.users.some(user => user.uid === partner.uid)
  );
  const defersInvitationRoster = isNewPartnerBooking && isInvitationSlot;
  const usesInternalRoster = isNewPartnerBooking
    || isPartnerOwnedBooking
    || Boolean(booking.bookingSeriesId)
    || (slot && slot.presetPlaces === 1)
    || (slots && slots.length === 1 && slots[0].presetPlaces === 1)
    || (slots && slots.length > 1);
  const hasLimitedCapacity = Number(bookingSlot.presetPlaces) > 1;
  const minimumRosterSize = hasLimitedCapacity && bookingSlot.minimumPlayers !== null
    ? Math.max(Number(bookingSlot.minimumPlayers) || 1, 1)
    : 1;
  const maximumRosterSize = hasLimitedCapacity
    ? Math.max(Number(bookingSlot.presetPlaces) || minimumRosterSize, minimumRosterSize)
    : Math.max(12, Number(booking.playersNumber) || 1);
  const rosterOptions = Array.from(
    {length: maximumRosterSize - minimumRosterSize + 1},
    (_, index) => minimumRosterSize + index
  );
  const persistedRosterSize = Math.max(Number(booking.playersNumber) || 1, Array.isArray(booking.otherPlayers) ? booking.otherPlayers.length : 0);
  const rosterSize = isPartnerOwnedBooking && isInvitationSlot
    ? Math.max(persistedRosterSize, minimumRosterSize)
    : persistedRosterSize;
  const bookingFixedCosts = (bookingSlot.costsPrice || 0) / 100;
  const calculateBookingTotal = participants => (
    slotPrice() * (hasLimitedCapacity ? Math.max(Number(participants) || 1, 1) : 1)
    + bookingFixedCosts
  );
  const bookingTotal = calculateBookingTotal(rosterSize);
  const otherPlayers = resizeArray(booking.otherPlayers, rosterSize, '');
  const otherPlayersPrice = resizeArray(booking.otherPlayersPrice, otherPlayers.length, 0);
  if (otherPlayersPrice.every(price => Number(price) === 0)) {
    if (hasLimitedCapacity) {
      const defaultShare = bookingTotal / Math.max(rosterSize, 1);
      otherPlayersPrice.fill(defaultShare);
    } else {
      otherPlayersPrice[0] = bookingTotal;
    }
  }
  const otherPlayersPayment = resizeArray(booking.otherPlayersPayment, otherPlayers.length, false);
  const otherPlayersMember = resizeArray(booking.otherPlayersMember, otherPlayers.length, false);
  const otherPlayersDiscountReason = resizeArray(booking.otherPlayersDiscountReason, otherPlayers.length, '');
  const persistedSeriesRoster = booking.bookingSeries && Array.isArray(booking.bookingSeries.roster)
    ? booking.bookingSeries.roster
    : [];
  const subscriptionRoster = otherPlayers.map((fullName, index) => {
    const persisted = index === 0 && booking.bookingSeries
      ? {
        uid: booking.bookingSeries.subscriberUid,
        firstName: booking.bookingSeries.subscriberName,
        surname: booking.bookingSeries.subscriberSurname,
        email: booking.bookingSeries.subscriberEmail,
        phoneNumber: booking.bookingSeries.subscriberPhoneNumber,
        ...(persistedSeriesRoster[index] || {})
      }
      : (persistedSeriesRoster[index] || {});
    const normalizedFullName = String(fullName || '').trim();
    const persistedFullName = String(persisted.name || '').trim();
    const keepIdentity = Boolean(persisted.uid) && normalizedFullName === persistedFullName;
    const parts = normalizedFullName.split(/\s+/).filter(Boolean);
    return {
      uid: keepIdentity ? persisted.uid : null,
      firstName: keepIdentity ? (persisted.firstName || parts[0] || '') : (parts[0] || ''),
      surname: keepIdentity ? (persisted.surname || parts.slice(1).join(' ')) : parts.slice(1).join(' '),
      email: keepIdentity ? (persisted.email || '') : '',
      phoneNumber: keepIdentity ? (persisted.phoneNumber || '') : ''
    };
  });
  let rtvChannels = slots && slots.length > 0 ? [...new Map(slots.map(s => s.rtvChannels).flat().map((item) => [item["id"], item])).values()] : slot.rtvChannels;
  
  const rtvChannelAssociations = slots && slots.length > 0 ? [...new Map(slots.map(s => s.rtvChannelAssociations).flat().map((item) => [item["rtvChannelId"], item])).values()] : slot.rtvChannelAssociations;
  rtvChannels.map(c => c.canPublish = rtvChannelAssociations.find(a => a.rtvChannelId === c.id).canPublish)

  return (
    <Formik
      enableReinitialize
      initialValues={Object.assign({}, booking, {
        description,
        bookingNotes,
        payment,
        otherPlayers,
        otherPlayersPrice,
        otherPlayersPayment,
        otherPlayersMember,
        otherPlayersDiscountReason,
        subscriptionRoster,
        discount,
        rtvChannels,
        subscriptionEnabled: false,
        subscriptionUntilDate: defaultUntilDate.toISOString(),
        subscriptionWeekDays: [defaultWeekDay],
        subscriptionMode: 'single',
        subscriberName: booking.partnerBookingName || '',
        subscriberSurname: booking.partnerBookingSurname || '',
        subscriberEmail: booking.partnerBookingEmail || '',
        subscriberPhoneNumber: booking.partnerBookingPhoneNumber || ''
      })}
      onSubmit={values => {
        const firstParticipant = values.subscriptionRoster && values.subscriptionRoster[0];
        const payload = values.subscriptionEnabled || values.bookingSeriesId
          ? {
            ...values,
            subscriberUid: firstParticipant ? firstParticipant.uid : null,
            subscriberName: firstParticipant ? firstParticipant.firstName : '',
            subscriberSurname: firstParticipant ? firstParticipant.surname : '',
            subscriberEmail: firstParticipant ? firstParticipant.email : '',
            subscriberPhoneNumber: firstParticipant ? firstParticipant.phoneNumber : ''
          }
          : values;
        return save(
          payload.bookingId && usesInternalRoster
            ? {...payload, multiBooking: false}
            : payload
        );
      }}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        setFieldValue
      }) => {

        if(values.description === "") values.description = null;

        const playerNumberChange = args => {
          const num = parseInt(args.target.value, 10);
          Object.keys(memberFullPrices.current).forEach(index => {
            if (Number(index) >= num) delete memberFullPrices.current[index];
          });
          setFieldValue('otherPlayers', resizeArray(values.otherPlayers, num, ''));
          setFieldValue('otherPlayersPrice', resizeArray(values.otherPlayersPrice, num, 0));
          setFieldValue('otherPlayersPayment', resizeArray(values.otherPlayersPayment, num, false));
          setFieldValue('otherPlayersMember', resizeArray(values.otherPlayersMember, num, false));
          setFieldValue('otherPlayersDiscountReason', resizeArray(values.otherPlayersDiscountReason, num, ''));
          setFieldValue('subscriptionRoster', resizeArray(values.subscriptionRoster, num, {
            uid: null,
            firstName: '',
            surname: '',
            email: '',
            phoneNumber: ''
          }));
          setFieldValue('playersNumber', num);
        };

        const updateSubscriptionParticipant = index => participant => {
          const updated = [...(values.subscriptionRoster || [])];
          updated[index] = participant;
          setFieldValue('subscriptionRoster', updated);
          setFieldValue(`otherPlayers[${index}]`, participantFullName(participant));
        };

        const handleSelectAll = ev => {
          const target = !values.payment;
          setFieldValue('payment', target);
          setFieldValue('otherPlayersPayment', values.otherPlayersPayment.map(() => target));
        };

        const splitBookingTotal = () => {
          const participants = Math.max(Number(values.playersNumber) || 1, 1);
          const currentBookingTotal = calculateBookingTotal(participants);
          const baseShare = Math.floor((currentBookingTotal * 100) / participants);
          const remainder = Math.round(currentBookingTotal * 100) - baseShare * participants;
          const fullShares = new Array(participants).fill(baseShare).map((share, index) => (
            (share + (index < remainder ? 1 : 0)) / 100
          ));
          const shares = fullShares.map((share, index) => {
            if (!values.otherPlayersMember[index]) return share;
            memberFullPrices.current[index] = share;
            return applyMemberDiscount(share, discount);
          });
          setFieldValue('otherPlayersPrice', shares);
        };

        const handleMemberChange = index => event => {
          const isMember = event.target.checked;
          const currentPrice = Number(values.otherPlayersPrice[index]) || 0;
          setFieldValue(`otherPlayersMember[${index}]`, isMember);

          if (isMember) {
            memberFullPrices.current[index] = currentPrice;
            setFieldValue(`otherPlayersPrice[${index}]`, applyMemberDiscount(currentPrice, discount));
            if (!values.otherPlayersDiscountReason[index]) {
              setFieldValue(`otherPlayersDiscountReason[${index}]`, t('PARTNER_BOOKING_MEMBER_DISCOUNT_REASON'));
            }
            return;
          }

          if (Object.prototype.hasOwnProperty.call(memberFullPrices.current, index)) {
            setFieldValue(`otherPlayersPrice[${index}]`, memberFullPrices.current[index]);
            delete memberFullPrices.current[index];
          }
          if (values.otherPlayersDiscountReason[index] === t('PARTNER_BOOKING_MEMBER_DISCOUNT_REASON')) {
            setFieldValue(`otherPlayersDiscountReason[${index}]`, '');
          }
        };

        const assignedTotal = (values.otherPlayersPrice || []).reduce((total, price) => (
          total + (Number(price) || 0)
        ), 0);
        const currentBookingTotal = calculateBookingTotal(values.playersNumber);
        const assignedDifference = assignedTotal - currentBookingTotal;
        const shouldDeferInvitationRoster = defersInvitationRoster
          && !values.subscriptionEnabled;
        const formatPrice = price => new Intl.NumberFormat(i18n.language, {
          style: 'currency',
          currency: 'EUR'
        }).format(price);

        return (
          <Form onSubmit={handleSubmit}>
            <Form.Label>{booking.bookingId ? resourceType === 'field' ? t('BOOKED_FIELD') : t('BOOKED_SERVICE') : resourceType === 'field' ? t('BOOKING_FIELD') : t('BOOKING_SERVICE')}: {field.name}, {field.sport}</Form.Label>
            <Form.Label>{t('BOOKING_AT')} {partner.name}, {partner.city}</Form.Label>
            <Form.Label>{t('BOOKING_DAY', {day: new Date(startSlot().startDatetime).toLocaleDateString(i18n.language, {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})})} {t('FROM_TO_TIME', {fromTime: new Date(startSlot().startDatetime).toLocaleTimeString(i18n.language).slice(0, 5), toTime: new Date(endSlot().endDatetime).toLocaleTimeString(i18n.language).slice(0, 5)})}</Form.Label>
            {
              slots && slots.length > 1 ?
                <Form.Label>{t('BOOKING_MULTI_SLOT')} ({slots.length})</Form.Label> :
                null
            }

            {isNewPartnerBooking ?
              <section className="partner-booking-subscription">
                <div className="partner-booking-subscription__heading">
                  <FaSyncAlt aria-hidden="true"/>
                  <div>
                    <h4>{t('BOOKING_SERIES_TITLE')}</h4>
                    <p>{t('BOOKING_SERIES_DESCRIPTION')}</p>
                  </div>
                </div>
                <Form.Check
                  id="subscriptionEnabled"
                  name="subscriptionEnabled"
                  type="switch"
                  label={t('BOOKING_SERIES_ENABLE')}
                  checked={Boolean(values.subscriptionEnabled)}
                  onChange={event => {
                    handleChange(event);
                    if (event.target.checked) {
                      const participants = Math.min(Math.max(Number(values.playersNumber) || 1, 1), 4);
                      playerNumberChange({target: {value: participants}});
                    }
                  }}
                />
                {values.subscriptionEnabled ?
                  <Fragment>
                    <div className="partner-booking-subscription__notice">
                      {t('BOOKING_SERIES_NO_WALLET')}
                    </div>
                    <Form.Group>
                      <Form.Label>{resourceType === 'field' ? t('BOOKING_PLAYERS_NUMBER') : t('BOOKING_USERS_NUMBER')}*</Form.Label>
                      <Form.Control required as="select" name="playersNumber" value={values.playersNumber || 1} onChange={playerNumberChange}>
                        {[1, 2, 3, 4].map(nPlayer => (<option key={nPlayer} value={nPlayer}>{nPlayer}</option>))}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{t('BOOKING_SERIES_UNTIL')}*</Form.Label><br/>
                      <DatePicker
                        required
                        className="form-control"
                        minDate={bookingStart}
                        selected={values.subscriptionUntilDate ? new Date(values.subscriptionUntilDate) : null}
                        dateFormat="dd/MM/yyyy"
                        onChange={value => setFieldValue('subscriptionUntilDate', value ? value.toISOString() : null)}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>{t('BOOKING_SERIES_WEEK_DAYS')}*</Form.Label>
                      <div className="partner-booking-subscription__weekdays">
                        {['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'].map((key, index) => {
                          const active = (values.subscriptionWeekDays || []).includes(index);
                          return (
                            <Button
                              type="button"
                              key={key}
                              variant={active ? 'primary' : 'outline-primary'}
                              aria-pressed={active}
                              onClick={() => setFieldValue(
                                'subscriptionWeekDays',
                                active
                                  ? values.subscriptionWeekDays.filter(day => day !== index)
                                  : [...(values.subscriptionWeekDays || []), index].sort()
                              )}
                            >{t(key)}</Button>
                          );
                        })}
                      </div>
                    </Form.Group>
                    <div className="partner-booking-subscription__participant-help">
                      <h5>{t('BOOKING_SERIES_PARTICIPANTS')}</h5>
                      <p>{t('BOOKING_SERIES_PARTICIPANTS_HELP')}</p>
                    </div>
                  </Fragment>
                : null}
              </section>
            : null}

            {booking.bookingSeriesId ?
              <section className="partner-booking-subscription partner-booking-subscription--existing">
                <div className="partner-booking-subscription__heading">
                  <FaSyncAlt aria-hidden="true"/>
                  <div>
                    <h4>{t('BOOKING_SERIES_BADGE')}</h4>
                    <p>{t('BOOKING_SERIES_OCCURRENCE', {
                      current: Number(booking.bookingSeriesOccurrence) + 1,
                      total: booking.bookingSeries ? booking.bookingSeries.occurrences : ''
                    })}</p>
                  </div>
                </div>
                <Form.Group>
                  <Form.Label>{t('BOOKING_SERIES_CHANGE_SCOPE')}</Form.Label>
                  <Form.Control as="select" name="subscriptionMode" value={values.subscriptionMode} onChange={handleChange}>
                    <option value="single">{t('BOOKING_SERIES_KEEP_OTHERS')}</option>
                    <option value="overwrite">{t('BOOKING_SERIES_OVERWRITE_FUTURE')}</option>
                  </Form.Control>
                </Form.Group>
                <Button
                  className="partner-booking-subscription__delete"
                  type="button"
                  variant="danger"
                  onClick={() => onRemoveSeries(booking.bookingSeriesId, resourceType, field.id)}
                >
                  <FaTrash aria-hidden="true"/>{t('BOOKING_SERIES_DELETE_FUTURE')}
                </Button>
              </section>
            : null}

            {
              // Le prenotazioni inserite dal circolo mantengono il roster interno alla
              // riapertura. Quelle a invito lo compilano dopo la creazione iniziale.
              usesInternalRoster ?
                <Fragment>
                  {
                    booking.bookingId ?
                      <Fragment>
                        <Form.Label>{t('BOOKING_OWNER')} {values.users[0].bookingOwner}</Form.Label>
                        <Form.Label>{t('BOOKING_INFO', {phoneNumber: values.users[0].phoneNumber, email: values.users[0].email})}</Form.Label>
                      </Fragment>
                    : null
                  }
                  <Form.Group>
                    <Form.Label>{t('DESCRIPTION')}*</Form.Label>
                    <Form.Control required name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange}/>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>{t('BOOKING_NOTES')}</Form.Label>
                    <Form.Control name="bookingNotes" as="textarea" rows={4} maxLength={255} placeholder={t('BOOKING_NOTES')} value={values.bookingNotes || ''} onChange={handleChange}/>
                  </Form.Group>
                  {                      
                    values.rtvChannels.length > 0 ?
                      <Fragment>
                        <Form.Label>
                          {t('WHERE_PUBLISH')}
                        </Form.Label>
                        {
                          values.rtvChannels.map((c, index) => (
                            <Form.Group key={c.id}>
                              <Form.Check
                                type="checkbox"
                                label={`Rtv ${c.name}`}
                                checked={c.canPublish}
                                onChange={() => {
                                  values.rtvChannels[index].canPublish = !values.rtvChannels[index].canPublish;
                                  setFieldValue('rtvChannels', values.rtvChannels);                                
                                }}/>                              
                            </Form.Group>
                          ))
                        }
                        <Form.Label>
                          {t('BOOKING_REPLAYER_TV_DESC')}
                        </Form.Label>
                      </Fragment> :
                      null
                  }
                  {
                    shouldDeferInvitationRoster ?
                      <div className="partner-booking-roster__notice partner-booking-roster__notice--deferred">
                        {t('PARTNER_BOOKING_ROSTER_AFTER_SAVE')}
                      </div>
                    :
                  <section className="partner-booking-roster">
                    <div className="partner-booking-roster__heading">
                      <span className="partner-booking-roster__icon"><FaUsers aria-hidden="true"/></span>
                      <div>
                        <h4>{t('PARTNER_BOOKING_ROSTER_TITLE')}</h4>
                        <p>{t('PARTNER_BOOKING_ROSTER_DESCRIPTION')}</p>
                      </div>
                    </div>
                    <div className="partner-booking-roster__notice">
                      {t('PARTNER_BOOKING_NO_ONLINE_PAYMENT')}
                    </div>
                    <div className="partner-booking-roster__tools">
                      {booking.bookingSeriesId || (values.subscriptionEnabled && !isInvitationSlot) ? null :
                        <Form.Group className="mb-0">
                          <Form.Label>{resourceType === 'field' ? t('BOOKING_PLAYERS_NUMBER') : t('BOOKING_USERS_NUMBER')}*</Form.Label>
                          <Form.Control required as="select" name="playersNumber" value={values.playersNumber || ''} onChange={playerNumberChange}>
                            <option value="">{t('BOOKING_PLAYERS_NUMBER_DESC')}</option>
                            {rosterOptions.map(nPlayer => (<option key={nPlayer} value={nPlayer}>{nPlayer}</option>))}
                          </Form.Control>
                        </Form.Group>
                      }
                      <Button type="button" variant="outline-primary" onClick={splitBookingTotal}>
                        <FaDivide aria-hidden="true"/>{t('PARTNER_BOOKING_SPLIT_TOTAL')}
                      </Button>
                    </div>
                    <div className="partner-booking-roster__summary">
                      <span>{t('PARTNER_BOOKING_FIELD_TOTAL')} <strong>{formatPrice(currentBookingTotal)}</strong></span>
                      <span>{t('PARTNER_BOOKING_ASSIGNED_TOTAL')} <strong>{formatPrice(assignedTotal)}</strong></span>
                      <span className={Math.abs(assignedDifference) < 0.01 ? 'is-balanced' : 'is-unbalanced'}>
                        {t('PARTNER_BOOKING_DIFFERENCE')} <strong>{formatPrice(assignedDifference)}</strong>
                      </span>
                    </div>
                    <Form.Check
                      className="partner-booking-roster__paid-all"
                      name="payment"
                      type="checkbox"
                      label={t('PAID_FOR_ALL')}
                      checked={values.payment}
                      onChange={handleSelectAll}
                    />
                    <div className="partner-booking-roster__list">
                      {(values.otherPlayers || []).map((participant, index) => (
                        <div className={`partner-booking-roster__row${values.subscriptionEnabled || booking.bookingSeriesId ? ' partner-booking-roster__row--subscription' : ''}`} key={`player_${index}`}>
                          <div className="partner-booking-roster__row-title">
                            <span>{index + 1}</span>
                            <strong>{resourceType === 'field' ? t('PARTNER_BOOKING_PLAYER') : t('PARTNER_BOOKING_CUSTOMER')}</strong>
                          </div>
                          {values.subscriptionEnabled || booking.bookingSeriesId ?
                            <PartnerBookingSubscriptionParticipant
                              index={index}
                              participant={values.subscriptionRoster[index] || {uid: null, firstName: '', surname: '', email: '', phoneNumber: ''}}
                              onChange={updateSubscriptionParticipant(index)}
                              searchPlayers={searchPlayers}
                              required={!isInvitationSlot}
                            />
                          :
                            <Form.Group>
                              <Form.Label>{t('PARTNER_BOOKING_FULL_NAME')}</Form.Label>
                              <Form.Control required={!isInvitationSlot} name={`otherPlayers[${index}]`} type="text" maxLength={50} value={participant || ''} onChange={handleChange}/>
                            </Form.Group>
                          }
                          <Form.Group>
                            <Form.Label>{t('PARTNER_BOOKING_INDIVIDUAL_FEE')}</Form.Label>
                            <Form.Control name={`otherPlayersPrice[${index}]`} type="number" min={0} max={1000} step={0.01} value={values.otherPlayersPrice[index] || 0} onChange={handleChange}/>
                          </Form.Group>
                          <div className="partner-booking-roster__checks">
                            <Form.Check name={`otherPlayersMember[${index}]`} type="checkbox" label={`${t('PARTNER_BOOKING_MEMBER')}${discount > 0 ? ` (-${discount}%)` : ''}`} checked={Boolean(values.otherPlayersMember[index])} onChange={handleMemberChange(index)}/>
                            <Form.Check name={`otherPlayersPayment[${index}]`} type="checkbox" label={t('PAID')} checked={Boolean(values.otherPlayersPayment[index])} onChange={handleChange}/>
                          </div>
                          <Form.Group className="partner-booking-roster__reason">
                            <Form.Label>{t('PARTNER_BOOKING_DISCOUNT_REASON')}</Form.Label>
                            <Form.Control name={`otherPlayersDiscountReason[${index}]`} type="text" maxLength={120} placeholder={t('PARTNER_BOOKING_DISCOUNT_REASON_PLACEHOLDER')} value={values.otherPlayersDiscountReason[index] || ''} onChange={handleChange}/>
                          </Form.Group>
                        </div>
                      ))}
                    </div>
                  </section>
                  }
                  <Button className="partner-booking-roster__save" type="submit" disabled={values.subscriptionEnabled && (values.subscriptionWeekDays || []).length === 0}>
                    <FaSave aria-hidden="true"/>{t(shouldDeferInvitationRoster ? 'BOOK' : 'SAVE')}
                  </Button>
                </Fragment>
              : 
                <Fragment>
                  {
                    values.presetPlaces > 1 && startSlot.minimumPlayers !== null ?
                      <Form.Group>
                        <Form.Label>{t('DESCRIPTION')}*</Form.Label>
                        <Form.Control required name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')} value={values.description || ''} onChange={handleChange}/>
                      </Form.Group>
                    :
                      <Form.Group>
                      <Form.Label>{t('DESCRIPTION')}: {values.description || ''} </Form.Label>
                      </Form.Group>
                    }
                  {
                      startSlot().minimumPlayers != null ?
                      <Form.Group>
                        <Form.Label>{t('GROUP_BOOKING_ACTIVE')}</Form.Label>
                      </Form.Group>
                      : null
                    }
                  {
                    values.users ?
                      <Form.Group>
                      {values.users.map(u => (
                          <Fragment key={u.id}>
                            <p>
                              {
                                u.payment ?
                                  <Button key={u.id} className="btn-block text-left" variant="outline-primary" style={{marginBottom: 20}} onClick={changeUserBooking(field.id, u)}>
                                    {
                                      u.uid === partner.uid ?
                                        <FaShieldAlt size="1.5em" style={{marginRight: 10}}/>
                                      : <AiOutlineUser size="1.5em" style={{marginRight: 10}}/>
                                    }
                                    {u.bookingOwner}{u.inviteType === 0 ? " - "+t('REFERENT') : u.inviteType === 1 ? " - "+t('PARTECIPANT') : u.inviteType === 2 ? " - "+t('GUEST') : ""}, {u.payment ? t('PAID') : t('TO_PAY')}
                                  </Button>
                                :
                                  <Button key={u.id} className="btn-block text-left" variant="outline-secondary" style={{marginBottom: 20}} onClick={changeUserBooking(field.id, u)}>
                                    {
                                      u.uid === partner.uid ?
                                        <FaShieldAlt size="1.5em" style={{marginRight: 10}}/>
                                      : <AiOutlineUser size="1.5em" style={{marginRight: 10}}/>
                                    }                                    
                                    {u.bookingOwner}, {(u.payment ? t('PAID') : t('TO_PAY')) + (u.uid === partner.uid ? ` ${(slotPrice() + slot.costsPrice/100).toFixed(2)}€` : "")}
                                  </Button>
                              }
                            </p>                            
                          </Fragment>
                          ))}
                      </Form.Group>
                    : null
                  }
                  <h4 style={{marginTop: 30}}>{t('NEW_BOOKING')}</h4>
                  <Form.Group>
                    <Form.Label>{t('NAME')}</Form.Label>
                    <Form.Control name="partnerBookingName" placeholder={t('NAME')} type="text" maxLength="50" value={values.partnerBookingName || ''} onChange={handleChange}/>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>{t('SURNAME')}</Form.Label>
                    <Form.Control name="partnerBookingSurname" placeholder={t('SURNAME')} type="text" maxLength="50" value={values.partnerBookingSurname || ''} onChange={handleChange}/>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>{t('EMAIL')}</Form.Label>
                    <Form.Control name="partnerBookingEmail" placeholder={t('EMAIL')} type="text" maxLength="255" value={values.partnerBookingEmail || ''} onChange={handleChange}/>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>{t('TELEPHONE')}</Form.Label>
                    <Form.Control name="partnerBookingPhoneNumber" type="tel" placeholder={t('TELEPHONE')} value={values.partnerBookingPhoneNumber || ''} onChange={handleChange}/>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>{t('BOOKING_NOTES')}</Form.Label>
                    <Form.Control name="bookingNotes" as="textarea" rows={4} maxLength={255} placeholder={t('BOOKING_NOTES')} onChange={handleChange}/>
                  </Form.Group>
                  <Button type="submit" variant="secondary" style={{marginBottom: 50}} onClick={() => values.multiBooking=true}>{t('BOOK')}</Button>
                </Fragment>
            }
            <Dialog
              ref={el => {
                dialog = el;
              }}/>
          </Form>
        );
      }}
    </Formik>
  );
};

PartnerBooking.propTypes = {
  booking: PropTypes.object,
  slot: PropTypes.object,
  field: PropTypes.object,
  partner: PropTypes.object,
  save: PropTypes.func.isRequired,
  slots: PropTypes.array,
  deleteUserBooking: PropTypes.func.isRequired,
  saveUserBooking: PropTypes.func.isRequired,
  deleteServiceUserBooking: PropTypes.func.isRequired,
  saveServiceUserBooking: PropTypes.func.isRequired,
  deleteBookingSeries: PropTypes.func.isRequired,
  searchPlayers: PropTypes.func,
  ownedFieldSlots: PropTypes.array,
  discount: PropTypes.number
};

PartnerBooking.defaultProps = {
  booking: null,
  slot: null,
  field: null,
  partner: null,
  slots: null,
  ownedFieldSlots: [],
  searchPlayers: null
};

const mapDispatchToProps = dispatch => ({
  deleteUserBooking: (fieldId, userBookingId) => {
    dispatch(deleteUserBooking(fieldId, userBookingId));
  },
  saveUserBooking: booking => {
    dispatch(saveUserBooking(booking));
  },
  deleteServiceUserBooking: (serviceId, userBookingId) => {
    dispatch(deleteServiceUserBooking(serviceId, userBookingId));
  },
  saveServiceUserBooking: booking => {
    dispatch(saveServiceUserBooking(booking));
  },
  deleteBookingSeries: (seriesId, resourceType, resourceId) => {
    dispatch(deleteBookingSeries(seriesId, resourceType, resourceId));
  },
  searchPlayers: (nickname, name, surname, affiliated) => dispatch(
    searchPartnerPlayers(nickname, name, surname, affiliated)
  ),
});

export default withRouter(connect(
  null,
  mapDispatchToProps
)(PartnerBooking));
